import React from 'react';
import { bonuses } from '../data/bonuses';
import { BookCover } from './BookCover';
export function Bonuses() {
  return <section aria-labelledby="bonuses-heading" className="w-full bg-navy" data-id="element-19" data-mp="pio8yn0kl492">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20" data-id="element-20" data-mp="avl8q8kv4hi1">
        <div className="text-center" data-id="element-21" data-mp="at8v27m50tas">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold" data-id="element-22" data-mp="fteh989n1nlh">
            Also included at no extra cost
          </p>
          <h2 id="bonuses-heading" className="mt-3 font-display font-bold uppercase text-white text-3xl sm:text-5xl" data-id="element-23" data-mp="1t3ou0sok0y7">
            Five instant-use <span className="text-gold" data-id="element-24" data-mp="3o2mz1kkfrgcs">bonuses</span>
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base text-white/75" data-id="element-25" data-mp="3t0g4uchtu8cj">
            The volumes give you the season. These five get you through your
            very next session — before it, during it, and when the plan falls apart.
          </p>
        </div>

        <div className="mt-9 grid gap-4 sm:grid-cols-2" data-id="element-26" data-mp="1r78tfe5c4avx">
          {bonuses.map((bonus, i) => <article key={bonus.number} className={`flex flex-col overflow-hidden rounded-2xl border border-navy-line bg-navy-card ${i === bonuses.length - 1 ? 'sm:col-span-2 sm:mx-auto sm:w-[calc(50%-8px)]' : ''}`} data-id="element-27" data-mp="3icbunweqtxof" data-mpi={i}>
              {bonus.cover ? <div className="aspect-[6/5] w-full overflow-hidden border-b border-navy-line bg-navy-deep" data-id="element-28" data-mp="2zglqq3n92r7w">
                  <img src={bonus.cover} alt={`${bonus.title} cover`} width={1024} height={1024} loading="lazy" className="h-full w-full object-cover" data-id="element-29" data-mp="2uhsnr55lailz" />
                </div> : <div className="flex h-[250px] items-center justify-center border-b border-navy-line bg-navy-mid sm:h-[300px]" data-id="element-30" data-mp="ns49e6h8o288">
                  <BookCover kicker={`Bonus ${bonus.number}`} title={bonus.title} accent={bonus.accent} className="h-[82%] w-auto -rotate-2" data-id="element-31" data-mp="3cj6h6da27qou" />
                </div>}
              <div className="px-5 pb-6 pt-4" data-id="element-32" data-mp="3lhry63zvuxni">
                <div className="flex flex-wrap items-center gap-2" data-id="element-33" data-mp="3qhmnw47x9h6z">
                  <span className="text-[11px] font-bold uppercase tracking-widest text-white/60" data-id="element-34" data-mp="2tsoscjsclf8r">
                    Bonus {bonus.number}
                  </span>
                  <span className="rounded bg-gold px-2 py-1 text-[10px] font-bold uppercase tracking-wider text-gold-ink" data-id="element-35" data-mp="2xua4g2x25phw">
                    Free today
                  </span>
                </div>
                <h3 className="mt-2.5 text-lg font-bold leading-snug text-white" data-id="element-36" data-mp="37lwl4es60gs1">
                  {bonus.title}
                </h3>
                <p className="mt-2 text-sm text-white/70" data-id="element-37" data-mp="2f395hevxttyc">{bonus.body}</p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}